import React, {Component} from 'react';
import bpotg from "../../../Resources/icons/be-part-of-the-game.svg";
import MaxButton from "../../MaxButton";
import {injectIntl} from "react-intl";
import {getFM} from "../../../Utilities/utils";
import './pScene10.css';

class PScene10 extends Component {
    render() {
        return <section id={'ps10c'} className={"p-container"}>
            <div id={'pscene10'} className='content'>
                <img id={'p-bpotg'} className={'p-bpotg accessibility-img'} src={bpotg} alt="Be Part of the Game"/>
                <div id={'ps10txt'} className={"p-text-container"}>
                    <h3 className={'p-text'}>
                        {getFM("home_start_planning_txt")}<br/>
                        {getFM("home_start_planning_txt_2")}
                    </h3>
                    <div className={"p-text left"}>
                        <MaxButton width={'50vw'} clickRoute={'contact'}>
                            home_start_planning_button
                        </MaxButton>
                    </div>
                </div>
            </div>
        </section>}
}
export default injectIntl(PScene10);
